
import React from 'react';
import { Check } from 'lucide-react';

const ChildrenJourney = () => {
  const journeySteps = [
    {
      title: "Musikalsk opdagelse",
      description: "I de første lektioner bliver dit barn bekendt med klaveret gennem leg og kreative aktiviteter.",
      points: [
        "Lære klaviaturets opbygning på en legende måde",
        "Udvikle grundlæggende fingerkontrol gennem sjove øvelser",
        "Opdage hvordan forskellige tangenter skaber forskellige lyde",
        "Skabe simple melodier og opleve musikalsk succes fra starten"
      ]
    },
    {
      title: "Grundlæggende færdigheder",
      description: "Gradvis opbygning af musikalske færdigheder med alderssvarende metoder.",
      points: [
        "Introduktion til nodelæsning gennem visuelle hjælpemidler og spil",
        "Udvikling af rytmefornemmelse med kropslige aktiviteter",
        "Lære enkle stykker der bygger på det lærte",
        "Opbygge gode øvevaner og selvstændighed"
      ]
    },
    {
      title: "Musikalsk vækst",
      description: "Uddybning af barnets musikalske forståelse og repertoire.",
      points: [
        "Lære mere komplekse stykker tilpasset barnets niveau og interesser",
        "Udvikle evnen til at udtrykke følelser gennem musik",
        "Forstå grundlæggende musikteori på en praktisk måde",
        "Mulighed for at deltage i små koncerter og opvisninger"
      ]
    }
  ];

  return (
    <section className="py-16">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-serif font-bold mb-4">
              Dit barns musikalske rejse
            </h2>
            <p className="text-lg text-gray-600">
              Klaverundervisning for børn er en gradvis proces, hvor læring sker gennem leg, 
              opdagelse og passende udfordringer, der motiverer og engagerer.
            </p>
          </div>
          
          <div className="space-y-12">
            {journeySteps.map((step, index) => (
              <div key={index} className="bg-white p-6 rounded-lg shadow-sm border border-gray-100">
                <div className="flex items-center mb-4">
                  <div className="w-10 h-10 rounded-full bg-piano-gold flex items-center justify-center text-white font-bold mr-4">
                    {index + 1}
                  </div>
                  <h3 className="text-xl font-serif font-semibold">{step.title}</h3>
                </div>
                <p className="text-gray-600 mb-4">{step.description}</p>
                <ul className="space-y-2">
                  {step.points.map((point, i) => (
                    <li key={i} className="flex items-start">
                      <Check className="w-5 h-5 text-piano-gold mr-2 mt-0.5 flex-shrink-0" />
                      <span className="text-gray-700">{point}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
          
          <div className="mt-12 bg-gray-50 p-6 rounded-lg border border-gray-200">
            <h3 className="text-xl font-serif font-semibold mb-4 text-center">Forældres rolle i barnets musikundervisning</h3>
            <p className="text-gray-600">
              Som forælder spiller du en vigtig rolle i dit barns musikalske udvikling. Jeg giver klare anvisninger 
              om, hvordan du kan støtte dit barns øvning derhjemme, uden at du behøver at have musikalsk erfaring selv. 
              Din opmuntring og interesse i dit barns fremskridt er en nøgle til deres succes og fortsatte motivation.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ChildrenJourney;
